import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import TextButton from '@spothero/ui/text-button';
import EventSchema from 'search/features/EventSchema';
import WithConfig from 'config/WithConfig';

class EventListItem extends Component {
    static propTypes = {
        timezone: PropTypes.string.isRequired,
        event: PropTypes.object.isRequired,
        destination: PropTypes.object.isRequired,
        city: PropTypes.object.isRequired,
        onClick: PropTypes.func.isRequired,
        isMobile: PropTypes.bool.isRequired,
        displayEventDateFormat: PropTypes.string.isRequired,
        siteUrl: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        const {
            event: {
                starts,
                ends,
            },
            timezone,
            displayEventDateFormat
        } = props;

        this._starts = moment.tz(
            starts,
            timezone
        );
        this._startsISO = this._starts.toISOString();
        this._startsDisplay = this._starts.format(displayEventDateFormat);
        this._ends = moment.tz(
            ends,
            timezone
        );
        this._endsISO = this._ends.toISOString();
    }

    _onClick = evt => {
        const {
            event,
            onClick
        } = this.props;

        evt.preventDefault();
        evt.stopPropagation();

        onClick(event);
    }

    render() {
        const {
            event: {
                title,
                search_url: eventUrl,
                meta_description: eventMetaDescription
            },
            destination,
            city,
            isMobile,
            siteUrl
        } = this.props;
        const containerProps = {
            className: 'EventListItem',
            itemScope: true,
            itemType: 'http://schema.org/Event'
        };

        if (isMobile) {
            containerProps.onClick = this._onClick;
        }

        return (
            <div {...containerProps} >
                <div className="EventListItem-details">
                    <TextButton
                        href={`/${eventUrl}`}
                        onClick={this._onClick}
                        title={title}
                    >
                        <span itemProp="name">
                            {title}
                        </span>
                    </TextButton>
                    <p>{this._startsDisplay}</p>
                </div>
                {!isMobile &&
                    <a
                        href={`/${eventUrl}`}
                        className="Button Button-primary"
                        onClick={this._onClick}
                    >
                        Select
                    </a>
                }
                <EventSchema
                    url={eventUrl}
                    metaDescription={eventMetaDescription}
                    starts={this._startsISO}
                    ends={this._endsISO}
                    destination={destination}
                    city={city}
                />
                <span
                    itemScope
                    itemProp="offers"
                    itemType="http://schema.org/AggregateOffer"
                >
                    <meta
                        itemProp="url"
                        content={`${siteUrl}/${eventUrl}`}
                    />
                </span>
            </div>
        );
    }
}

export default WithConfig(EventListItem);
